// src/objects/deepMerge.ts
function isPlainObject(value) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return false;
  }
  return Object.getPrototypeOf(value) === Object.prototype;
}
function deepMerge(target, source) {
  if (target === void 0) {
    return source === void 0 ? {} : { ...source };
  }
  if (source === void 0) {
    return { ...target };
  }
  const out = { ...target };
  for (const key of Object.keys(source)) {
    if (key === "__proto__" || key === "constructor" || key === "prototype") {
      continue;
    }
    const srcVal = source[key];
    if (srcVal === void 0) {
      continue;
    }
    const tgtVal = out[key];
    if (isPlainObject(tgtVal) && isPlainObject(srcVal)) {
      out[key] = deepMerge(tgtVal, srcVal);
    } else {
      out[key] = srcVal;
    }
  }
  return out;
}

export { deepMerge };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map